__turbopack_context__.v({
  "blok-big-title": "ScrollToTop-module__QLuXhW__blok-big-title",
  "blok-subtitle": "ScrollToTop-module__QLuXhW__blok-subtitle",
  "blok-title": "ScrollToTop-module__QLuXhW__blok-title",
  "scroll-to-top": "ScrollToTop-module__QLuXhW__scroll-to-top",
});
